import { render, staticRenderFns } from "./shopDecoration.vue?vue&type=template&id=0f7848e8&scoped=true"
import script from "./shopDecoration.vue?vue&type=script&lang=js"
export * from "./shopDecoration.vue?vue&type=script&lang=js"
import style0 from "./shopDecoration.vue?vue&type=style&index=0&id=0f7848e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7848e8",
  null
  
)

export default component.exports